import { useIntl } from 'react-intl';
import Comment from './Comment';
import Tag from './Tag';
import { IInfoParkingTag, IInfoRideTag } from '../interfaces';
import {
  getCommentEditPermission,
  getCommentRemovePermisson,
  getUsageRemovePermission,
} from '../TripsOverviewService';

interface ICommentsProps {
  rideId: string;
  customerId: number;
  locked: string;
  rideComment: string | null;
  parkingComment: string | null;
  rideTags: IInfoRideTag[];
  parkingTags: IInfoParkingTag[];
}

function CommentsAndTags(props: ICommentsProps): JSX.Element {
  const { formatMessage: f } = useIntl();

  return (
    <div
      className="w-waypoints-timeline"
      style={{ height: '180px' }}
      data-cy="ride-book-comments-tags"
    >
      <div className="font-weight-bold mb-2">{f({ id: 'tripsOverview.comments.title' })}</div>
      <div className="mb-4">
        <div className="text-gray-light fs-1 font-weight-bold mb-2">
          {f({ id: 'table.rideBook.modal.ToRide' })}
        </div>
        <div>
          {props.rideComment && (
            <Comment
              comment={props.rideComment}
              rideId={props.rideId}
              customerId={props.customerId}
              isEditable={getCommentEditPermission(props.customerId, props.locked)}
              isRemovable={getCommentRemovePermisson(props.customerId, props.locked)}
            />
          )}
          {props.rideTags.map((item) => (
            <div key={item.id} className="row no-gutters flex-nowrap">
              <Tag
                id={item.id}
                name={item?.name || ''}
                color={item.color}
                rideId={props.rideId}
                customerId={props.customerId}
                isRemovable={getUsageRemovePermission(props.customerId, props.locked)}
              />
            </div>
          ))}
          {!props.rideComment && props.rideTags.length === 0 && (
            <div className="ml-2"> {f({ id: 'table.rideBook.modal.nothing' })}</div>
          )}
        </div>
      </div>
      <div className="mb-4">
        <div className="text-gray-light fs-1 font-weight-bold mb-2">
          {f({ id: 'table.rideBook.modal.toParking' })}
        </div>
        {props.parkingComment && (
          <Comment
            comment={props.parkingComment}
            rideId={props.rideId}
            customerId={props.customerId}
            isParking={true}
            isEditable={getCommentEditPermission(props.customerId, props.locked)}
            isRemovable={getCommentRemovePermisson(props.customerId, props.locked)}
          />
        )}
        {props.parkingTags.map((item) => (
          <div key={item.id} className="row no-gutters flex-nowrap">
            <Tag
              id={item.id}
              name={item?.name || ''}
              color={item.color}
              rideId={props.rideId}
              customerId={props.customerId}
              isParking={true}
              isRemovable={getUsageRemovePermission(props.customerId, props.locked)}
            />
          </div>
        ))}
        {!props.parkingComment && props.parkingTags.length === 0 && (
          <div className="ml-2"> {f({ id: 'table.rideBook.modal.parking.nothing' })}</div>
        )}
      </div>
    </div>
  );
}

export default CommentsAndTags;
